import { createContext } from "react";
export const DependencyInjectionContext = createContext({ container: null });
